// ============================================================
// Page Publications : comment une ligne du journal se raconte
// ============================================================
// Fonctions pures, sans React ni accès réseau, testées par publicationsModel.test.ts (node --test).

/** Ce que la page lit d'une ligne du journal (sous-ensemble de DeployRequestDTO). */
export interface JournalRow {
  status: 'pending' | 'publishing' | 'accepted' | 'refused' | 'failed';
  requestedBy: string;
  decidedBy: string | null;
  direct?: boolean;
}

/** Qui a fait quoi, en une phrase : « publiée par X », « demandée par X, acceptée par Y »... */
export function whoLine(r: JournalRow): string {
  if (r.direct) {
    if (r.status === 'failed') return `publication de ${r.requestedBy} en échec`;
    if (r.status === 'publishing') return `publication de ${r.requestedBy} en cours`;
    return `publiée par ${r.requestedBy}`;
  }
  const by = r.decidedBy ? ` par ${r.decidedBy}` : '';
  if (r.status === 'accepted') return `demandée par ${r.requestedBy}, acceptée${by}`;
  if (r.status === 'refused') return `demandée par ${r.requestedBy}, refusée${by}`;
  if (r.status === 'failed') return `demandée par ${r.requestedBy}, en échec`;
  return `demandée par ${r.requestedBy}`;
}

/** Pastille d'état : publiée directement, acceptée après demande, refusée, en échec, en attente. */
export function statusLabel(r: JournalRow): { tone: 'pending' | 'ok' | 'ko'; text: string } {
  if (r.status === 'pending') return { tone: 'pending', text: 'En attente' };
  if (r.status === 'publishing') return { tone: 'pending', text: 'En cours' };
  if (r.status === 'accepted') return { tone: 'ok', text: r.direct ? 'Publiée' : 'Acceptée' };
  if (r.status === 'refused') return { tone: 'ko', text: 'Refusée' };
  return { tone: 'ko', text: 'Échec' };
}
